import { HttpClient } from 'api/http-client';
import { Automation } from './types';

class CustomAutomationsHttpClient extends HttpClient {
  public getAllAutomations() {
    return this.get<Automation[]>(
      '/custom-automations?automationType=CUSTOM_AUTOMATION',
    );
  }

  public getAllAutomationsForParams(params: Record<string, any>) {
    return this.get<Automation[]>('/custom-automations', { params });
  }
}

export const CustomAutomationsApi = new CustomAutomationsHttpClient();
